import { BondsCall } from '../type';

export const isPostCall = (evtEntrySIdEvtCode: BondsCall['EVT_ENTRY_S.ID_EVT_CODE'] | undefined) => evtEntrySIdEvtCode === 323;
